import PropTypes from "prop-types";

const OutreachTabGroup = ({ activeTab, onTabChange, draftsCount }) => {
  return (
    <div style={{ display: "flex", justifyContent: "space-between" }}>
      <div className="outreach-tab-group">
        <div
          className={`outreach-tab-group--item ${activeTab === "Drafts" ? "active-tab" : ""}`}
          onClick={() => onTabChange("Drafts")}
        >
          <span className="tab-text">Drafts {draftsCount}</span>
        </div>
        <span className="border-span"> | </span>
        <div
          className={`outreach-tab-group--item ${activeTab === "Scheduled" ? "active-tab" : ""}`}
          onClick={() => onTabChange("Scheduled")}
        >
          <span className="tab-text">Scheduled</span>
        </div>
        <span className="border-span"> | </span>
        <div
          className={`outreach-tab-group--item ${activeTab === "Sent" ? "active-tab" : ""}`}
          onClick={() => onTabChange("Sent")}
        >
          <span className="tab-text">Sent</span>
        </div>
      </div>
    </div>
  );
};

OutreachTabGroup.propTypes = {
  activeTab: PropTypes.string.isRequired,
  onTabChange: PropTypes.func.isRequired,
  draftsCount: PropTypes.number.isRequired,
};

export default OutreachTabGroup;
